import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import useApi from "../../hooks/useApi";
import { Navigate, useNavigate } from "react-router-dom";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import { images } from "../../assets/images";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import { icons } from "../../assets/icons";

const ChangePassword = () => {
  const { login, user } = useAuth();
  const { apiCall: CHANGE_PASSWORD_API } = useApi();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    confirmPassword: "",
    currentPassword: "",
    newPassword: "",
  });

  const [PASSWORD_FIELDS, SET_PASSWORD_FIELDS] = useState([
    {
      title: "Enter Current Password",
      value: "currentPassword",
      isPassShow: false,
      icons: icons.passwordIcon,
    },
    {
      title: "Enter New Password",
      value: "confirmPassword",
      isPassShow: false,
      icons: icons.passwordIcon,
    },
    {
      title: "Confirm New Password",
      value: "newPassword",
      isPassShow: false,
      icons: icons.passwordIcon,
    },
  ]);

  const onClickChangePassword = (e) => {
    e.preventDefault();
    // const deviceCode = generateDeviceCode();
    const userDetail = {
      confirmPassword: formData.confirmPassword,
      currentPassword: formData.currentPassword,
      newPassword: formData.newPassword,
    };
    if (
      formData?.confirmPassword?.length > 0 &&
      formData?.currentPassword?.length > 0 &&
      formData?.newPassword?.length > 0
    ) {
      //   setLoader(true);
      // if(String(deviceCode).length > 0){
      let dataToSend = userDetail;
      CHANGE_PASSWORD_API({
        url: `${apiUrls.user.changepassword}`,
        dataToSend,
        method: "post",
        onSuccess: () => {
          // toast.success("Voucher has been saved succesfully");
          setFormData({
            confirmPassword: "",
            currentPassword: "",
            newPassword: "",
          });
          setLoader(false);
          toast.success("You have successfully changed your Password!!");
          navigate("/login");
          // navigate(-1);
        },
        onFail: (err) => {
          const { response = {} } = err || {};
          toast.error(response?.data?.message || "Something Went Wrong");
        },
      });
      //   CHANGE_PASSWORD_API({
      //     // DEVICE_CODE: deviceCode,
      //     param: userDetail,
      //   })
      //     .then((res) => {
      //       console.log("res of access token", res);
      //       // debugger
      //       const { data = "", code = 500 } = res?.data || {};
      //       if (data.length > 0 && code === 200) {
      //         // Reset the form after handling submission
      //         setFormData({
      //           confirmPassword: "",
      //           currentPassword: "",
      //           newPassword: "",
      //         });
      //         setLoader(false);
      //         toast.success("You have successfully changed your Password!!")
      //         navigate("/");
      //       } else {
      //         const { message = "", timestamp = "" } = res?.response?.data || {};
      //         // message &&
      //         //   showCustomAlert({
      //         //     title: "Error",
      //         //     bodyMsg: message,
      //         //     underTitle: timestamp,
      //         //     dispatch: dispatch,
      //         //   });
      //         setLoader(false);
      //         // Reset the form after handling submission
      //         setFormData({
      //           confirmPassword: "",
      //           currentPassword: "",
      //           newPassword: "",
      //         });
      //       }
      //     })
      //     .catch((err) => {
      //       setLoader(false);
      //       // Reset the form after handling submission
      //       setFormData({
      //         confirmPassword: "",
      //         currentPassword: "",
      //         newPassword: "",
      //       });
      //     });
      // }
    } else {
      console.log("");
      // showCustomAlert({
      //   title: "Error",
      //   bodyMsg: "Something Went Wrong",
      //   // underTitle: timestamp,
      //   dispatch: dispatch
      // })
    }
  };
  const formDataHandler = (e) => {
    const { name, value } = e.target || {};
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const returnToDash = () => {
    navigate("/");
  };

  //   const toggleIsPassShowHandler = (v) => {
  //     SET_PASSWORD_FIELDS((prev) => {
  //       return prev.map((field) => {
  //         if (field.value === v) {
  //           return { ...field, isPassShow: !field.isPassShow };
  //         }
  //         return field;
  //       });
  //     });
  //   };
  if (!user?.access_token) {
    return <Navigate to="/login" />;
  }
  return (
    <div
      className="login-container"
      style={{
        background: `url(${images.loginBackground}) no-repeat center center/cover`,
      }}
    >
      <div className="login-form-container">
        <img
          src={images.mainLogo}
          className="main-logo"
          alt="keventer's logo"
        />
        {/* <div className='font-size-medium text-center mt-[-1.6rem] font-[500] font-["Fraunces"]'>
          KICS - Keventers Internal Communication System
        </div> */}
        <div className="login-form flex flex-col justify-center">
          <div className="font-family-medium font-size-large mb-6">
            Enter Details To Change Your Password
          </div>
          {PASSWORD_FIELDS.map((item, ind) => (
            <InputWithIcon
              key={ind}
              leftIcon={item.icons}
              placeholder={item.title}
              containerClassName="mb-4"
              wrapperClassName="w-[100%]"
              onChange={formDataHandler}
              autoComplete={"username"}
              value={formData[item.value]}
              name={item.value}
              fullEventData
            />
          ))}
          {/* <InputWithIcon
            leftIcon={icons.userIcon}
            placeholder="Enter your username"
            containerClassName="mb-4"
            wrapperClassName="w-[100%]"
            onChange={(text) => setUsername(text)}
            autoComplete={"username"}
            value={}
          />
          <InputWithIcon
            leftIcon={icons.passwordIcon}
            rightIcon={!hidePass ? icons.openEye : icons.closeEye}
            rightIconHandler={() => {
              setHidePass((prev) => !prev);
            }}
            rightIconStyle={{ top: "14px", right: "13px", cursor: "pointer" }}
            placeholder="Password"
            wrapperClassName="w-[100%]"
            onChange={(text) => setPassword(text)}
            autoComplete={hidePass ? "password" : "text"}
            type={hidePass ? "password" : "text"}
          /> */}
          <div className=" flex justify-end mt-1 w-[100%]">
            {/* <Checkbox
            title="Remember Me"
            checked={rememberMe}
            onChange={(isChecked) => setRememberMe(isChecked)}
          />             */}
            {/* <div className="font-size-small text-[var(--appColor)] cursor-pointer">
              Reset Password?
            </div> */}
            <div className="flex justify-end cursor-pointer">
              {/* <Form.Check type="checkbox" label="Remember Me" /> */}
              <span
                style={{ color: "#DB0106", fontSize: "14px" }}
                onClick={returnToDash}
              >
                Return to Dashboard
              </span>
            </div>
          </div>
          <button
            className="login-button font-family-bold font-size-large !h-[5.8rem]"
            onClick={onClickChangePassword}
            type="button"
          >
            Submit
          </button>
          <div className="font-size-small text-[var(--ultraLightGray)] mt-6 m-auto">
            &copy; Powered by CorePeelers
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
